import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.PARAMETERS_LIST, { params: payload }),
    addParameter: payload => axios.post(HTTP.PARAMETER, payload),
    updateParameter: payload => axios.put(HTTP.PARAMETER, payload),
    deleteParameter: payload => axios.delete(HTTP.PARAMETER, { params: { id: payload } })
}
